import { elements } from '../periodicElements';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { handleElementClick, renderElementVideo, renderColumn } from '../FunctionsElements';
import { useTranslation } from 'react-i18next';

export default function Frameworks() {
  const [selectedElement, setSelectedElement] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section>
      {selectedElement ? (
        <section className="bg-background-secondary min-h-screen flex items-center justify-center p-4">
          <div className="flex items-center justify-center w-full max-w-4xl">
            {renderElementVideo(selectedElement, setSelectedElement, t, navigate)}
          </div>
        </section>
      ) : (
        /* pt-28 para garantir que o botão apareça abaixo da sua Navbar */
        <section className="mx-auto min-h-screen p-4 pt-28 bg-background-secondary">
          
          {/* Botão isolado no topo com margem para a tabela */}
          <div className="w-full flex justify-start mb-8 md:ml-8 lg:ml-12">
            <Link to="/TPQVS"> 
              <button 
                className="bg-buttom text-white font-bold py-2 px-6 rounded-md shadow-lg transition-transform transform hover:scale-105 hover:bg-opacity-90">
                {t("elements.back")}
              </button>
            </Link>
          </div>

          <div className="flex flex-col sm:flex-row justify-center items-center sm:items-start gap-8">
            <div className="grid grid-cols-2 text-center gap-0">
              {renderColumn(elements, 53, 56, true, 1, handleElementClick, setSelectedElement, true)} 
              {renderColumn(elements, 56, 59, true, 1, handleElementClick, setSelectedElement, true)} 
            </div>

            {/* Card de Texto Informativo */}
            <div className="w-full p-6 sm:w-1/2 lg:w-1/3 bg-surface border border-border-light rounded-lg shadow-lg text-text-primary mt-6 sm:mt-0 xl:mt-16">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center mb-4 border-b-2 border-green-600 text-text-primary">
                {t("ConceptualFrameworks.title")} 
              </h2>
              <p className="text-xs sm:text-sm md:text-base leading-relaxed text-justify text-text-secondary">
                {t("ConceptualFrameworks.discretion")} 
              </p>
            </div>
          </div>
        </section>
      )}
    </section>
  );
}